import React, { useState, useEffect } from 'react';
import { Container } from '@/components';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import {
  uploadBtsManualPdfAPI,
  getCurrentBtsManualPdfAPI,
} from '@/services/BtsService';
import { FaFilePdf } from 'react-icons/fa';

const UploadBtsManual = () => {
  const [currentManual, setCurrentManual] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    fetchCurrentManual();
  }, []);

  const fetchCurrentManual = async () => {
    try {
      const data = await getCurrentBtsManualPdfAPI();
      if (data) {
        setCurrentManual(data);
      }
    } catch (error) {
      console.error('Error fetching current manual:', error);
    }
  };

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      const newManual = await uploadBtsManualPdfAPI(files[0]);
      if (newManual) {
        setCurrentManual(newManual);
        setSelectedFiles([]);
      }
    } else {
      alert('Please select a file to upload.');
    }
  };

  return (
    <Container title={'Upload BTS Manual PDF'}>
      <div className="flex justify-center flex-col items-center">
        <div className="w-full max-w-2xl mb-8">
          <p className="text-gray-500 mb-6 text-center">
            Please upload a PDF file containing the BTS Manual.
            <br />
            <span className="text-sm text-blue-600">
              This PDF will be automatically attached to all quote sharing emails.
            </span>
          </p>

          <FileUploadTemplate
            acceptedFileTypes={['.pdf']}
            onFilesSelected={handleFilesSelected}
            multiple={false}
            onUpload={handleUpload}
            maxFiles={1}
          />
        </div>

        <div className="w-full max-w-2xl mb-8">
          <h3 className="text-lg font-medium text-gray-700 mb-4 border-b pb-2">Current Active Manual</h3>
          {currentManual ? (
            <div className="flex items-center p-4 bg-gray-50 rounded border">
              <FaFilePdf className="text-red-500 text-3xl mr-4" />
              <div>
                <p className="font-semibold text-gray-800">{currentManual.fileName}</p>
                <p className="text-xs text-gray-500">
                  Uploaded on: {new Date(currentManual.uploadTimestamp).toLocaleString()}
                </p>
                <a 
                  href={currentManual.s3Url} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="text-blue-600 text-sm hover:underline mt-1 inline-block"
                >
                  View File
                </a>
              </div>
            </div>
          ) : (
            <p className="text-gray-500 italic">No manual has been uploaded yet.</p>
          )}
        </div>
      </div>
    </Container>
  );
};

export default UploadBtsManual;
